import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../../assets/image 6.svg'

import { StyledMenu, StyledBurger } from './styles.js'

export const Menu = ({ open }) => {
  const { pathname } = useLocation();
  return (
    <StyledMenu open={open}>
      <img src={logo} alt="Ocariot" />
      <div className="links-div">

        <Link to="dashboard" className={(pathname === "/dashboard") && 'active'}>
          Missões
        </Link>
        <Link to="physical-activity" className={(pathname === "/physical-activity") && 'active'}>
          Atividade Física
        </Link>
        <Link to="sleep-habits" className={(pathname === "/sleep-habits") && 'active'}>
          Hábitos de sono
        </Link>
      </div>
    </StyledMenu>
  )
}


export const Burger = ({ open, setOpen }) => {
  return (
    <StyledBurger open={open} onClick={() => setOpen(!open)}>
      <div />
      <div />
      <div />
    </StyledBurger>
  )
}

